export const DEFAULT_GARANT_EMAIL = 'customer.success@arnold-robot.com';
export const EN_LANGUAGE_CODE = 'en';
export const CHAT_OVERVIEW_LOGIN_REQUIRED_FOR_MANAGERS_ERROR_MESSAGE =
  'Login required for managers to view the overview';
export const CREDITS_USAGE_THRESHOLD = 0.8;
export const ACCESS_TOKEN_NOT_FOUND_ERROR_MESSAGE = 'Access token not found';
export const EMAIL_ADDRESS_REGEX =
  /^[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~])*@(([a-zA-Z0-9]\.)|([a-zA-Z0-9]([-a-zA-Z0-9]{0,61}[a-zA-Z0-9])\.))+[a-zA-Z0-9]([-a-zA-Z0-9]{0,61}[a-zA-Z0-9])$/;

export const CREDIT_PRICING = {
  ONE_TIME: 1,
  ONBOARDING: 4,
  EXIT: 1.5,
  HIRING: 6,
  PROCESS: 4,
  PUBLIC_SURVEY: 1,
  MANUAL_DEDUCTION: 1,
  PULSER: 4,
};

export const ONB_RETURN_CREDITS_DAYS = 14;
export const ONB_RETURN_CREDITS_AMOUNT = 2;
